import { useEffect, useState } from "react";
import {
  DeleteCategoryService,
  GetCategoriesService,
  UpdateCategoryService,
} from "../../../services/categories.service";
import { IColumns } from "../user.interface";
import { StatusCodes } from "http-status-codes";
import { useNavigate } from "react-router-dom";
import Switch from "react-switch";
import { toast } from "react-toastify";
import { ICategoryBaseResponse, ICategoryDetail } from "./category.interface";
import Paginate from "../../../components/Paginate";
import TableLoader from "../../../components/TableLoader";
const Categories = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [category, setCategory] = useState<ICategoryBaseResponse>();
  const columns: IColumns[] = [
    {
      title: "Name",
      key: "name",
    },
    {
      title: "Description",
      key: "description",
    },
    {
      title: "Status",
      key: "status",
    },
    {
      title: "Action",
      key: "action",
    },
  ];
  const GetCategories = async (pageNumber: number) => {
    setLoading(true);
    const response = await GetCategoriesService(pageNumber);
    if (response.status && response.status_code === StatusCodes.OK) {
      setCategory(response.data);
    }
    setLoading(false);
  };
  useEffect(() => {
    GetCategories(page);
  }, [page]);
  const handleChangeStatus = async (checked: boolean, row: ICategoryDetail) => {
    const response = await UpdateCategoryService(row.id, {
      ...row,
      status: checked ? "1" : "0",
    });
    if (response.status && response.status_code === StatusCodes.OK) {
      toast.success("Category status updated successfully");
    }
    await GetCategories(page);
  };

  const handleDeleteCategory = async (id: any) => {
    if (window.confirm("Are you sure you want to delete category?")) {
      const response = await DeleteCategoryService(id);
      if (response.status && response.status_code === StatusCodes.OK) {
        const deletedCat = category?.data?.filter((x) => x.id !== id);
        setCategory(deletedCat as any);
        toast.success(response.message);
      }
    }
    await GetCategories(page);
  };
  return (
    <div className="flex justify-center items-center flex-col">
      <h1>Categories</h1>
      <a
        href="/admin/add-category"
        className="underline text-blue-500 cursor-pointer mt-2"
      >
        Add
      </a>
      {loading ? (
        <TableLoader />
      ) : (
        <table className="mt-4">
          <thead>
            <tr>
              {columns.map((column) => {
                return (
                  <th align="left" key={column.key}>
                    {column.title}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {category?.data?.map((row, index) => {
              return (
                <tr
                  key={index}
                  className={`${index % 2 === 0 ? "bg-pink-50" : ""}`}
                >
                  <td align="left">{row?.name}</td>
                  <td align="left">{row?.description}</td>
                  <td align="left">
                    <Switch
                      id={row.id as any}
                      onChange={(checked: boolean) =>
                        handleChangeStatus(checked, row)
                      }
                      checked={row?.status === "1" ? true : false}
                    />
                  </td>
                  <td align="left">
                    <button
                      onClick={() =>
                        navigate(`/admin/update-category/${row.id}`)
                      }
                      className="border-2 px-1 border-gray-600 bg-gray-400"
                    >
                      edit
                    </button>
                    &nbsp;
                    <button
                      onClick={() => handleDeleteCategory(row?.id as any)}
                      className="border-2 px-1 border-gray-600 bg-gray-400"
                    >
                      delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
      {category?.data?.length! > 10 ? (
        <Paginate
          total_pages={category?.links!}
          page={page}
          setPage={setPage}
        />
      ) : null}
    </div>
  );
};

export default Categories;
